export const AGE_BOUNDS_MIN = 13;
export const AGE_BOUNDS_MAX = 65;

export const GENDER_MALE = 'm';
export const GENDER_FEMALE = 'f';

export const METERS_IN_KM = 1000;
export const METERS_IN_MI = 1609.34;

export const UNIT_KM = 'km';
export const UNIT_MI = 'mi';

// TODO - change this to 11 (when map all tiles will be uploaded), used as max zoom for offline mode
export const MAP_OFFLINE_ZOOM = 4;

export const IDB_NAME = 'gotu:agent';
export const IDB_TABLE_LOCATIONS = 'locations'; // IDB table for offline locations

export const IDB_LOCALFORAGE = `${IDB_NAME}:localforage`;
export const IDB_LOCALFORAGE_TABLE_GENERAL = 'general'; // IDB table for generic key/value pairs

export const SW_MESSAGE_SOURCE = `${IDB_NAME}:sw`;
export const SW_DB_KEYS = {
  hosts: 'service-worker:hosts',
  lastStatus: 'service-worker:last-status',
  lastOnline: 'service-worker:last-online',
  lastFileUpdate: 'service-worker:last-file-update',
};

export const OFFLINE_DRAFT_PREFIX = 'offline:';
export const ONLINE_DRAFT_PREFIX = 'draft-';

export const ENV_IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const ENV_IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const ENV_IS_TESTING = process.env.NODE_ENV === 'testing';

export const LOCALE_DEFAULT = 'en';
export const LOCALE_DEVELOPMENT = 'dev';
export const LOCALE_FALLBACK = ENV_IS_DEVELOPMENT ? undefined : LOCALE_DEFAULT;

export const GOOGLE_MAPS_KEY = process.env.GOOGLE_MAPS_KEY;

export const DOCUMENT_TITLE = process.env.DOCUMENT_TITLE || 'GotU Agent';

export const PHP_CONFIG_PATH = '/php/config.php';

export const DEFAULT_FAVICON_URL = '/static/favicon.ico';

export const MAX_LOCATION_COUNT = 20; // api fails if more than 20 locations

export const CAMPAIGN_SUBSCRIPTION = {
  periodCount: '999',
  periodLength: '1',
  periodType: 'months',
  periodTypes: ['month', 'months', 'day', 'days'],
  minChangePriceInterval: 14,
};

export const PROPOSALS_COLUMNS = {
  drafts: ['created', 'locations', 'nextStep', 'goal', 'creator'],
  checkout: ['created', 'name', 'company', 'goal', 'creator'],
  completed: ['created', 'name', 'company', 'goal', 'status', 'code', 'creator'],
  live: ['created', 'name', 'company', 'goal', 'status', 'code', 'creator'],
};



// WEBPACK FOOTER //
// ./src/util/constants.js